import * as React from 'react'

import DesktopListTable from '~/client/src/desktop/tables/DesktopListTable'
import type { UseTableListResult } from '~/client/src/desktop/tables/useTableList'
import {
  Empty,
  EmptyDescription,
} from '~/client/src/shared/components/shadcn-ui/empty'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { ICompanyRow } from '../types'

interface ITableProps {
  list: UseTableListResult<ICompanyRow>
  onEditCompany: (companyId: string) => void
}

export default function CompaniesTable({
  list,
  onEditCompany,
}: ITableProps): React.ReactElement {
  const t = Localization.translator

  return (
    <DesktopListTable
      list={list}
      ariaLabel={t.companyDirectory}
      fillContainerWidth
      onActivate={record => onEditCompany(record.id)}
      emptyState={
        <Empty>
          <EmptyDescription>
            {t.thereAreNoInstancesToDisplay(t.companies)}
          </EmptyDescription>
        </Empty>
      }
    />
  )
}
